<template>
    <div class="secondaryMenu">
        <ul class="secondaryMenu-list">
            <li v-for="(item, index) of menuItemsStored">
                <a :href="item.link" :target="item.newWindow ? '_blank' : null">{{item.text}}</a>
            </li>
             <li>
                <a  id="ot-sdk-link" class="ot-sdk-show-settings" href="#">Cookies Settings</a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: ['secondaryMenuItems'],
    data() {
        return {
            menuItemsStored: []
        };
    },
    created() {
        this.menuItemsStored = this.secondaryMenuItems;
    }
}
</script>

<style lang="scss">
</style>